export { default as IconAppleStore } from './iconAppleStore';
export { default as IconFacebook } from './iconFacebook';
export { default as IconInstagram } from './iconInstagram';
export { default as IconLinkdin } from './iconLinkedin';
export { default as IconPlayStore } from './iconPlayStore';
export { default as IconTwitter } from './iconTwitter';
export { default as IconWhatsapp } from './iconWhatsapp';
export { default as IconYoutube } from './iconYoutube';
export { default as IconZoom } from './iconZoom';
export { default as IconMessenger } from './iconMessenger';
export { default as IconSymplaDark } from './iconSymplaDark';
export { default as IconAgenda } from './iconAgenda';
